"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayout = exports.Layout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Layout_1 = require("@reactionable/core/lib/ui/layout/Layout");
const Body_1 = require("./body/Body");
const Footer_1 = require("./footer/Footer");
const Header_1 = require("./header/Header");
function Layout(props) {
    return (jsx_runtime_1.jsx(Layout_1.Layout, Object.assign({}, Object.assign({ HeaderComponent: Header_1.Header, BodyComponent: Body_1.Body, FooterComponent: Footer_1.Footer }, props)), void 0));
}
exports.Layout = Layout;
function useLayout(props) {
    return Layout_1.useLayout(Object.assign({ HeaderComponent: Header_1.Header, BodyComponent: Body_1.Body, FooterComponent: Footer_1.Footer }, props));
}
exports.useLayout = useLayout;
//# sourceMappingURL=Layout.js.map